module.exports = __webpack_public_path__ + "img/sow-logo-azul-naval.82c2d5a3.png";